import { TableRow } from '@mui/material';

interface IProps {
    enabled?: boolean
    onClick: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void
    children: React.ReactNode
}


let ClickableTableRow: React.FC<IProps & Record<string, any>> = ({ children, enabled = true, onClick, ...rest }: IProps) => {

    return (
        <TableRow
            sx={{ cursor: enabled === true ? 'pointer' : 'default' }}
            onClick={onClick}
            {...rest}
        >
            {children}
        </TableRow>
    )
}

export default ClickableTableRow;